import { Plus } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

const allDeductions = [
  "Professional Tax",
  "Income Tax",
  "Provident Fund",
  "Employee State Insurance",
  "Labour Welfare Fund",
  "Meal Deduction",
  "Transport Deduction",
  "Advance Salary",
  "Loan Repayment",
  "Insurance Premium",
  "Union Fees",
];

export function DeductionDropdown({ deductions, setDeductions }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredDeductions = allDeductions.filter((deduction) =>
    deduction.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-sm text-[#27004a] font-semibold flex items-center mt-[4px] justify-center gap-1"
      >
        <Plus className="w-4 h-4" />
        Add Deduction
      </button>

      {isOpen && (
        <div className="absolute z-10 bottom-full mb-2 w-64 rounded-md shadow-lg bg-white">
          <div className="p-2">
            <input
              type="text"
              placeholder="Search deductions"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none "
            />
          </div>
          <ul className="max-h-60 overflow-auto py-1">
            {filteredDeductions.map((deduction, index) => (
              <li
                key={index}
                className="px-4 py-2 text-sm font-light text-gray-900 hover:bg-gray-50 cursor-pointer"
                onClick={() => {
                  if (!deductions.some((item) => item.name === deduction)) {
                    setDeductions([
                      ...deductions,
                      { name: deduction, amount: "", type: "On Attendance" },
                    ]);
                    setIsOpen(false);
                  }
                }}
              >
                {deduction}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
